import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';

const generateJourneyId = commit => {
  let journeyId = Cookies.get('journey_id');
  if (!journeyId) {
    journeyId = uuidv4();
    Cookies.set('journey_id', journeyId, {
      expires: 1 / 48, // 1day/48hours = 30minutes
    });
  }
  commit('setJourneyId', journeyId);
};

export const state = () => ({
  journeyId: '',
});

export const getters = {
  getJourneyId: state => state.journeyId,
  hasVoucher: state => (state.referral.voucher ? '1' /* has voucher */ : '0') /* has no voucher */,
  userType(state) {
    let userType = '2'; // non_user
    const { login, userId } = (state.auth && state.auth.token) || {};
    if (login && userId) {
      // eslint-disable-next-line
      const { o2o_agent } = state.user.user;
      userType = o2o_agent ? '1' /* mitra */ : '0' /* non_mitra */;
    }
    return userType;
  },
  getCurrentUserId36(state) {
    const { login, userId } = state.auth.token;
    return (login && userId ? userId : '0').toString(36);
  },
  getCurrentUserId(state) {
    const { userId } = state.auth.token;
    return userId;
  },
};

export const mutations = {
  setJourneyId(state, data) {
    state.journeyId = data;
  },
};

export const actions = {
  async nuxtClientInit({ dispatch, _, commit }, { query }) {
    await dispatch('auth/requestToken', { query });
    // generate new journeyId for newly loaded/refreshed page
    generateJourneyId(commit);
  },
  generateJourneyId({ commit }) {
    generateJourneyId(commit);
  },
  resetState({ commit }) {
    commit('resetState');
  },
  aggregate({ commit }, bundlePack) {
    commit('yieldAggregate', bundlePack);
  },
};
